import { ADDITIONAL_SERVICES_CODES } from '@/utils/Constants';

const INSURANCE_CODES = [
  ADDITIONAL_SERVICES_CODES.INSR1,
  ADDITIONAL_SERVICES_CODES.INSR2,
  ADDITIONAL_SERVICES_CODES.INSR3,
  ADDITIONAL_SERVICES_CODES.INSR4,
];

export default {
  methods: {
    isInsuranceOrder(services) {
      return services.some(s => INSURANCE_CODES.includes(s.code));
    },
    getInsuranceCost(services) {
      const insuranceService = services.find(s => INSURANCE_CODES.includes(s.code));
      return insuranceService ? insuranceService.cost : 0;
    },
    getInsuranceAmount(order, isLateCancel) {
      // cancellationPenaltyAmount > 0 "с вас будет удержано УБО EUR" - Late cancel
      if (isLateCancel) {
        return this.getInsuranceCost(this.order.additionalServiceItems);
      }
      // cancellationPenaltyAmount < 0 "Сумма возврата %сумма предоплаты (c УБО)%" - cancel
      return order.prepayAmount;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/insurance.js